module.exports = __webpack_public_path__ + "saira-regular-webfont.178a740bcd3a252997c1.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-regular-webfont.ttf
// module id = ../../../../../src/assets/fonts/saira-regular-webfont.ttf
// module chunks = styles